import {AdminPagingModel} from "./AdminPagingModel";
import {LocationService} from "../../services/LocationService";
import {PrintJobService} from "../../services/PrintJobService";
import {NotificationService} from "../../services/NotificationService";
import {GridBookmarkService} from "../../services/GridBookmarkService";
import {Template} from "../../entities/Template";
import {PrintJob} from "../../entities/PrintJob";
import {Location} from "../../entities/Location";

export class LocationAdminPagingModel extends AdminPagingModel<Location>{
    static $inject = ['$q','LocationService','PrintJobService','NotificationService','GridBookmarkService'];
    constructor($q:ng.IQService, pagingService:LocationService,
                public printjobService:PrintJobService,
                public notificationService:NotificationService,
                gridBookmarkService:GridBookmarkService){
        super($q, pagingService,notificationService,gridBookmarkService);
    }
    getCustomActions():string[]{
        return ["Batch Print", "Server Import", "Import", "Export"];
    }
    print(template:Template){
      var ids:number[] = this.selectedItems.map<number>((p)=> p.id);
      var printJobs:PrintJob[] = [];
        for (var i = 0; i < ids.length; i++){
            var printJob: PrintJob = new PrintJob(null, ids[i], "Location", template.id, template.useWithService);
        printJobs.push(printJob);
      }
      this.printjobService.prints(printJobs).then(()=>{
        this.notificationService.notify("Print Jobs Scheduled successfully.");
      })
      .catch((exc)=>{
        this.notificationService.notifyError("Error printing", exc);
      });
    }
    printTemplateType(): string {
        return "Location";
    }
    entityName():string{
        return "location";
    }
    displayName():string{
        return "Locations";
    }
    getColumnDefs():ng.IPromise<void>{
        this.nameValuePairs =
            [
                ['name', 'Name', 150],
                ['rfidTag', 'RFID Tag', 215],
                ['site', 'Site', 125],
                ['building', 'Building', 135],
                ['floor', 'Floor', 150],
                ['room', 'Room', 150],
                ['description', 'Description', 150],
            ];
        return this.$q.when();
    }
}
